import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cargo-storage',
  templateUrl: './cargo-storage.component.html',
  styleUrls: ['./cargo-storage.component.scss']
})
export class CargoStorageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
